var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStandard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 173,
    height: 167,
    viewBox: "15 10 145 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n        stroke: #606060;\r\n        stroke-width: 1.1px;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #c6c6c6;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke: none;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    transform: "translate(257.762 -115.937)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    className: "cls-1",
    width: 173,
    height: 167,
    transform: "translate(-257.762 115.937)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    className: "cls-2",
    transform: "translate(-225.191 128.444)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 107.531,
    height: 140.475
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.55,
    y: 0.55,
    width: 106.431,
    height: 139.375
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    className: "cls-2",
    transform: "translate(-215.814 137.297)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 88.776,
    height: 122.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.55,
    y: 0.55,
    width: 87.676,
    height: 121.67
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    className: "cls-3",
    width: 86.7,
    height: 90,
    transform: "translate(-214.762 138.337)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandard);
export default __webpack_public_path__ + "static/media/Standard.af8dc13843646efa33a06ba3458fc1d3.svg";
export { ForwardRef as ReactComponent };